import { JSX, lazy, Suspense } from 'react'
import { styled } from 'styled-components'

import { IconSize } from './Icons'

const HeartEmoji = lazy(() => import('./emojis/HeartEmoji'))
const HeyThereEmoji = lazy(() => import('./emojis/HeyThereEmoji'))
const IndexFingerUpEmoji = lazy(() => import('./emojis/IndexFingerUpEmoji'))
const RaisedHandsEmoji = lazy(() => import('./emojis/RaisedHandsEmoji'))
const ThumbUpEmoji = lazy(() => import('./emojis/ThumbUpEmoji'))
const HappyFaceEmoji = lazy(() => import('./emojis/HappyFaceEmoji'))
const ShinyStarsEmoji = lazy(() => import('./emojis/ShinyStarsEmoji'))

export type EmojiType = 'thumbUp' | 'raisedHands' | 'heart' | 'heyThere' | 'indexFingerUp' | 'happyFace' | 'shinyStars'

export const emojis: Record<EmojiType, JSX.Element> = {
  heart: <HeartEmoji />,
  heyThere: <HeyThereEmoji />,
  indexFingerUp: <IndexFingerUpEmoji />,
  raisedHands: <RaisedHandsEmoji />,
  thumbUp: <ThumbUpEmoji />,
  happyFace: <HappyFaceEmoji />,
  shinyStars: <ShinyStarsEmoji />,
}

const EmojiFallback = styled.div`
  width: ${IconSize.EXTRALARGE}px;
  height: ${IconSize.EXTRALARGE}px;
`

export const GetEmoji = (type: EmojiType): JSX.Element => {
  const emoji = emojis[type]
  return <Suspense fallback={<EmojiFallback />}>{emoji}</Suspense>
}
